import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    header: 'heading-xs mb-4 flex flex-col gap-4',
    headerFirstBlock: 'flex w-full justify-between',
    headerSecondBlock: 'flex w-full justify-between gap-1 max-xl:flex-col',
    authorInfoContainer: 'flex items-center justify-between',
    authorName: 'heading-m-bold',
    date: 'heading-xs text-secondary-hover',
    authorMeta: 'heading-xs text-main xl:self-center xl:text-end',
    image: 'size-16 object-cover',
    carousel: '[--slide-size:auto] [--slide-spacing:4px]',
    content: 'flex flex-col gap-3'
  }
});
